/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryInactivateAliases {
  FIELD_JUSTFY = 'field-justfy',
  FORM_HEALTH_HISTORY_INACTIVATE = 'form-health-history-inactivate',
  LAYOUT_HEALTH_HISTORY_INACTIVATE = 'layout-health-history-inactivate',
  PANEL_HEALTH_HISTORY_INACTIVATE = 'panel-health-history-inactivate',
  TEXT_AREA_JUSTIFY = 'text-area-justify',
}
export { HealthHistoryInactivateAliases };
